interface PrizeSnapshot {
  prizePool: number | string;
  displayPrizePool?: number;
}

/** Use the latest snapshot, keeping manual display projections separate from collected funds. */
export function getDisplayPrizePool(
  timer: PrizeSnapshot | null | undefined,
  tournament: PrizeSnapshot | null | undefined,
): number {
  const snapshot = timer ?? tournament;
  const value = Number(snapshot?.displayPrizePool ?? snapshot?.prizePool ?? 0);
  return Number.isFinite(value) ? Math.trunc(value) : 0;
}
